module.exports = __webpack_public_path__ + "img/39.e7694cf7.jpg";